export default "__VITE_ASSET__a173f8b2__"